/* AimGrips Cart — AJAX quantity updates, line removal, add-on upsells,
   promo redirect, and quantity-based free shipping (US) with live re-render. */
(function () {
  'use strict';

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function init(cartEl) {
    if (cartEl.dataset.agcInit === 'true') return;
    cartEl.dataset.agcInit = 'true';

    var fsEnabled = cartEl.getAttribute('data-fs-enabled') === 'true';
    var fsQty = parseInt(cartEl.getAttribute('data-fs-qty'), 10) || 0;
    var fsCost = parseInt(cartEl.getAttribute('data-fs-cost'), 10) || 0;

    /* Re-render summary + line prices + free-shipping state from cart JSON */
    function applyCart(cart) {
      if (cart.item_count === 0) { window.location.reload(); return; }

      var count = cartEl.querySelector('[data-agc-count]');
      if (count) count.textContent = cart.item_count;

      var total = cartEl.querySelector('[data-agc-total]');
      if (total) total.textContent = money(cart.total_price);

      /* Per-line totals + compare-at savings */
      var compareSavings = 0;
      cart.items.forEach(function (item) {
        var row = cartEl.querySelector('[data-agc-item][data-key="' + item.key + '"]');
        if (row) {
          var compareEach = parseInt(row.getAttribute('data-compare-each'), 10) || 0;
          if (compareEach > item.original_price) compareSavings += (compareEach - item.original_price) * item.quantity;
          var lineTotal = row.querySelector('[data-agc-line-total]');
          if (lineTotal) lineTotal.textContent = money(item.final_line_price);
          var lineCompare = row.querySelector('[data-agc-line-compare]');
          if (lineCompare) {
            if (compareEach > item.price) {
              lineCompare.textContent = money(compareEach * item.quantity);
              lineCompare.hidden = false;
            } else {
              lineCompare.hidden = true;
            }
          }
          var qtyInput = row.querySelector('[data-agc-qty-input]');
          if (qtyInput) qtyInput.value = item.quantity;
        }
      });
      var savings = compareSavings + (cart.total_discount || 0);

      /* Subtotal = full pre-discount value (compare-at where higher, else regular price) */
      var subtotal = cartEl.querySelector('[data-agc-subtotal]');
      if (subtotal) subtotal.textContent = money(cart.original_total_price + compareSavings);

      /* Items removed server-side but still in DOM → drop the row */
      Array.prototype.forEach.call(cartEl.querySelectorAll('[data-agc-item]'), function (row) {
        var key = row.getAttribute('data-key');
        var found = cart.items.some(function (i) { return i.key === key; });
        if (!found) row.remove();
      });

      /* Quantity-based free shipping (e.g. 3+ items = free US shipping) */
      var fsQualified = fsEnabled && fsQty > 0 && cart.item_count >= fsQty;
      if (fsEnabled) {
        var shipOld = cartEl.querySelector('[data-agc-ship-old]');
        var shipVal = cartEl.querySelector('[data-agc-ship-val]');
        if (shipOld) shipOld.hidden = !fsQualified;
        if (shipVal) {
          shipVal.textContent = fsQualified ? (shipVal.getAttribute('data-free-text') || 'FREE') : money(fsCost);
          shipVal.classList.toggle('agc-ship-free', fsQualified);
        }
        if (fsQualified) savings += fsCost;

        var remaining = Math.max(0, fsQty - cart.item_count);
        Array.prototype.forEach.call(cartEl.querySelectorAll('[data-agc-fs-bar]'), function (bar) {
          bar.style.width = Math.min(100, Math.round(cart.item_count * 100 / fsQty)) + '%';
        });
        Array.prototype.forEach.call(cartEl.querySelectorAll('[data-agc-fs-label]'), function (label) {
          label.textContent = fsQualified
            ? (label.getAttribute('data-unlocked-text') || 'You unlocked FREE shipping!')
            : (label.getAttribute('data-away-prefix') || 'Add') + ' ' + remaining + ' ' + (label.getAttribute('data-away-suffix') || 'more for FREE shipping');
        });
        Array.prototype.forEach.call(cartEl.querySelectorAll('[data-agc-fs-count]'), function (el) {
          el.textContent = remaining;
        });
        var nudge = cartEl.querySelector('[data-agc-fs-nudge]');
        if (nudge) nudge.hidden = fsQualified;
      }

      /* Total savings row (compare-at + discounts + unlocked shipping) */
      var savingsRow = cartEl.querySelector('[data-agc-savings-row]');
      var savingsEl = cartEl.querySelector('[data-agc-savings]');
      if (savingsRow && savingsEl) {
        savingsRow.hidden = savings <= 0;
        savingsEl.textContent = '−' + money(savings);
      }

      /* Header cart bubble (Dawn-style; no-op elsewhere) */
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      fetch(root() + '?sections=cart-icon-bubble')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var el = document.getElementById('cart-icon-bubble');
          if (el && data['cart-icon-bubble']) {
            var tmp = document.createElement('div');
            tmp.innerHTML = data['cart-icon-bubble'];
            var inner = tmp.querySelector('.shopify-section') || tmp.firstElementChild;
            if (inner) el.innerHTML = inner.innerHTML;
          }
        })
        .catch(function () {});
    }

    function changeLine(row, quantity) {
      row.classList.add('is-busy');
      fetch(root() + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: row.getAttribute('data-key'), quantity: quantity })
      })
        .then(function (r) { if (!r.ok) throw new Error('change failed'); return r.json(); })
        .then(function (cart) { row.classList.remove('is-busy'); applyCart(cart); })
        .catch(function () { window.location.reload(); });
    }

    /* Quantity steppers + manual input */
    Array.prototype.forEach.call(cartEl.querySelectorAll('[data-agc-item]'), function (row) {
      var input = row.querySelector('[data-agc-qty-input]');
      Array.prototype.forEach.call(row.querySelectorAll('[data-agc-qty-change]'), function (btn) {
        btn.addEventListener('click', function () {
          var next = Math.max(0, (parseInt(input.value, 10) || 1) + parseInt(btn.getAttribute('data-agc-qty-change'), 10));
          changeLine(row, next);
        });
      });
      if (input) {
        input.addEventListener('change', function () {
          changeLine(row, Math.max(0, parseInt(input.value, 10) || 1));
        });
      }
      var remove = row.querySelector('[data-agc-remove]');
      if (remove) {
        remove.addEventListener('click', function (e) {
          e.preventDefault();
          changeLine(row, 0);
        });
      }
    });

    /* Add-on upsells + free-shipping nudge products */
    Array.prototype.forEach.call(cartEl.querySelectorAll('[data-agc-addon]'), function (addon) {
      var btn = addon.querySelector('[data-agc-addon-add]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        addon.classList.add('is-busy');
        btn.disabled = true;
        fetch(root() + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: parseInt(addon.getAttribute('data-variant-id'), 10), quantity: 1 })
        })
          .then(function (r) { if (!r.ok) throw new Error('add failed'); window.location.reload(); })
          .catch(function () { addon.classList.remove('is-busy'); btn.disabled = false; });
      });
    });

    /* Promo code — Shopify applies discount codes via the /discount/ URL */
    var promo = cartEl.querySelector('[data-agc-promo]');
    if (promo) {
      promo.addEventListener('submit', function (e) {
        e.preventDefault();
        var code = promo.querySelector('input').value.trim();
        if (code) window.location.href = root() + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(root() + 'cart');
      });
    }
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-agc-cart]'), init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();